import React, { useState } from "react";
// import Checkbox from "../Checkbox";
// import Accordion from "../Accordion";
// import OutputFactory from "../OutputFactory";
import CollapseView from "./CollapseView";
// import AccordionProvider from "../Accordion/AccordionProvider";
// import AccordionCollapse from "../Accordion/AccordionCollapse";
import { Checkbox } from "../../nq-component";
import AccordionProvider from "../../nq-component/Accordion/AccordionProvider";
import { motion } from "framer-motion";
import { container, item } from "../../animationUtils";
import Accordion from "../Accordion";
import OutputFactory from "../OutputFactory";
import AccordionCollapse from "../Accordion/AccordionCollapse";

let timeoutId;

function Body({
  objects,
  fields,
  collapsableFields,
  excludeFields,
  selected,
  selectable,
  onSelect,
  onClick,
  onLongPress,
  actionsList,
  collapsable,
  toggleable,
  actions,
  onEdit,
  fieldImage,
  onCollapse,
  onToggleBoolean,
  numbering,
  unselectable = {},
  showActions,
}) {
  const [collapsedRows, setCollapsedRows] = useState([]);

  const onPointerDown = () => {
    timeoutId = setTimeout(onLongPress, 500);
  };

  const onPointerUp = () => {
    clearTimeout(timeoutId);
  };

  const toggleCollapse = (index) => {
    setCollapsedRows((prevState) => {
      const newCollapsedRows = [...prevState];
      if (newCollapsedRows.includes(index)) {
        return newCollapsedRows.filter((i) => i !== index);
      } else {
        return [...newCollapsedRows, index];
      }
    });
  };

  return objects.map((object, index) => {
    const id = object.id || object._id;
    const checked = selected.includes(object);
    const isCollapsed = collapsedRows.includes(index);
    const hasMatch = Object.entries(unselectable).some(([key, value]) => {
      return object.hasOwnProperty(key) && object[key] === value;
    });

    return (
      <AccordionProvider key={id}>
        <motion.tr
          variants={container(0.1)}
          initial="hidden"
          animate="show"
          onClick={() => onClick(object, index)}
        >
          {selectable && (
            <th className="align-middle">
              {!hasMatch && (
                <Checkbox
                  checked={checked}
                  id={"check_" + id}
                  onChange={() => onSelect(index)}
                />
              )}
            </th>
          )}
          {numbering || numbering === 0 ? (
            <th className="text-muted fw-light text-center align-content-center small">
              {numbering === 0 ? index + 1 : numbering + index}
            </th>
          ) : (
            ""
          )}

          {Object.keys(fields).map((field, i) => {
            const options = fields[field];
            if (excludeFields.includes(field)) return null;
            const isToggleBooleanCell =
              field === "isActive" && onToggleBoolean != null;
            const cellContent = (
              <OutputFactory
                field={field}
                object={object}
                {...options}
                onChange={
                  onToggleBoolean
                    ? (fieldName, value) =>
                        onToggleBoolean(object, fieldName, value)
                    : undefined
                }
              />
            );
            if (isToggleBooleanCell) {
              return (
                <motion.td
                  variants={item}
                  key={field}
                  className="fs-sm text-truncate text-center"
                  style={{ maxWidth: "15em" }}
                  onClick={(e) => e.stopPropagation()}
                >
                  {cellContent}
                </motion.td>
              );
            }
            return (
              <Accordion
                as={motion.td}
                eventKey={`_${id}`}
                variants={item}
                key={field}
                className="fs-sm text-truncate text-center"
                onPointerDown={onPointerDown}
                onPointerUp={onPointerUp}
                style={{
                  cursor: "pointer",
                  maxWidth: "15em",
                }}
              >
                {cellContent}
              </Accordion>
            );
          })}
          {actionsList.length > 0 && (
            <td>
              <div style={{ width: "50px" }}></div>
            </td>
          )}
          {actionsList.map((action) => (
            <td className="text-truncate" key={action.label}>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  action.onClick && action.onClick(object);
                }}
                className="btn btn-outline-primary btn-sm fs-xs shadow-none"
              >
                <i className={action.icon} /> {action.label}
              </button>
            </td>
          ))}
          <td>
            <div>
              <i
                className={
                  !isCollapsed ? "bi bi-chevron-down" : "bi bi-chevron-up"
                }
                style={{ color: "#1c4a77" }}
              ></i>
            </div>
          </td>
          {/* </tr> */}
        </motion.tr>

        {collapsable && (
          <tr>
            <td className="p-0" colSpan={Object.keys(fields).length + 1}>
              <AccordionCollapse
                toggleable={toggleable}
                className="collapse py-2 px-3 bg-light"
                eventKey={`_${id}`}
              >
                {onCollapse(id, object) ||
                  CollapseView(
                    id,
                    object,
                    collapsableFields,
                    fields,
                    actions,
                    onEdit,
                    showActions,
                    fieldImage,
                  )}
              </AccordionCollapse>
            </td>
          </tr>
        )}
      </AccordionProvider>
    );
  });
}

export default Body;
